var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeatureIcon23({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.76728 16.501H0V24.3398H7.76728V16.501Z",
    fill: "#FFBC07"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0017 2H32.2344V9.83886H40.0017V2Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0017 31.0029H32.2344V38.8418H40.0017V31.0029Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6702 18.2656H7.37891V22.1845H37.6702V18.2656Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0017 16.501H32.2344V24.3398H40.0017V16.501Z",
    fill: "#2650FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6634 3.66504V7.58394H16.31V32.8647H37.6634V36.7836H12.4258V3.66504H37.6634Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3477 18.2647V22.1836H32.2308V18.2647H28.3477Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureIcon23);
export default __webpack_public_path__ + "static/media/feature_icon_2_3.fe0d9b4a589c698f969f5673856326ff.svg";
export { ForwardRef as ReactComponent };